/**
 * Standalone module (no local imports) so `appConfig.ts` can import it
 * without a cycle.
 *
 * Env override wins if explicitly set ("true"/"false"); otherwise derive from
 * hostname. Must be a STATIC `process.env.REACT_APP_*` member expression —
 * Vite inlines it by textual replacement at build time (see `envPlugin` in
 * vite.config.ts); dynamic access is not inlined.
 */
const override = process.env.REACT_APP_IS_MITTI_BRAND;

export const isMittiBrand =
  override != null && override !== ""
    ? override === "true"
    : typeof window !== "undefined" &&
      window.location.hostname.includes("insurance.mitti.com");

export const brand = {
  isMittiBrand,
  fullName: isMittiBrand ? "Mitti Insurance" : "SafetyCulture Care",
  shortName: isMittiBrand ? "Mitti Insurance" : "Care",
  pageTitle: isMittiBrand ? "Mitti Insurance" : "SafetyCulture Care",
  // The parent company (SafetyCulture) is rebranding to Mitti. Use this for
  // references to the parent company / account-creation-and-login identity
  // (e.g. "create an account with ___", "___'s Terms and Conditions") — NOT
  // for the SafetyCulture inspection app/product itself, which keeps its name
  // (e.g. "the SafetyCulture app", "SafetyCulture inspection", "SafetyCulture
  // ID").
  parentName: isMittiBrand ? "Mitti" : "SafetyCulture",
} as const;
